import { DashboardContext } from './useDashboardContext';
import useSidePanel from './useSidePanel';

export default function DashboardProvider({ children }: { children: React.ReactElement }) {
  const contextValue = useSidePanel();

  return <DashboardContext.Provider value={contextValue}>{children}</DashboardContext.Provider>;
}
